import * as Types from '../../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type SelectStandalonePackageMutationVariables = Types.Exact<{
	packagesShortName?: Types.InputMaybe<Types.Scalars['String']['input']>;
	packagesShortNames?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
	cascadeDeselectBundles?: Types.Scalars['Boolean']['input'];
	state: Types.Scalars['Boolean']['input'];
	country: Types.Scalars['Country']['input'];
	platform?: Types.Platform;
}>;

export type SelectStandalonePackageMutation = {
	__typename?: 'Mutation';
	setPackage: {
		__typename?: 'UpdateSettingsPayload';
		packages: Array<{
			__typename?: 'Package';
			id: string;
			selected: boolean;
			bundles: Array<{ __typename?: 'Bundle'; id: string; selected: boolean }>;
			addons: Array<{ __typename?: 'Package'; id: string; selected: boolean }>;
		}>;
	};
};

export const SelectStandalonePackageDocument = gql`
	mutation SelectStandalonePackage(
		$packagesShortName: String
		$packagesShortNames: [String!]
		$cascadeDeselectBundles: Boolean! = false
		$state: Boolean!
		$country: Country!
		$platform: Platform! = WEB
	) {
		setPackage(
			input: {
				cascadeDeselectBundles: $cascadeDeselectBundles
				state: $state
				package: $packagesShortName
				packages: $packagesShortNames
				country: $country
				platform: $platform
			}
		) {
			packages(country: $country, platform: $platform) {
				id
				selected
				bundles(platform: $platform, country: $country) {
					id
					selected
				}
				addons(country: $country, platform: $platform) {
					id
					selected
				}
			}
		}
	}
`;
